import '@angular/localize/init';
export * from './lib/feature-tax-dividend-details.module';

export * from './lib/tax-dividend-details/feature-tax-dividend-details.component';
